
import React, { Component } from 'react';
import SEARCH_IMG from "../img/search.png";
import YOUTUBE_IMG from "../img/youtube.png";

class Search extends Component {
    
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.handleClick = this.handleClick.bind(this);
      }

    handleClick=()=>{
        this.props.onSearchVideo(this.ref.current.value);
        this.ref.current.value ="";
    }

    handleEnterKey = () =>{
        if (window.event.keyCode === 13) {
            this.props.onSearchVideo(this.ref.current.value);
            this.ref.current.value ="";
        }
    }

    render() {
        return (
            <div className = "search">
                <div className = "search-title"><div className="search_title-img"></div>&nbsp;CloneTube</div>
                <div className = "search-search">
                    <input type="text" className="search-form-input" placeholder="검색..."  ref = {this.ref} onKeyUp = {this.handleEnterKey}/>
                    <button className="search-button" onClick={this.handleClick}></button>
                </div>
            </div>
        );
    }
}

export default Search;